import { Directive, effect, input } from '@angular/core';

import { injectTooltipTriggerState, NgpTooltipTrigger } from 'ng-primitives/tooltip';

import { TooltipComponent } from './tooltip.component';
import { type TooltipContext, type TooltipCva, type TooltipPlacement } from './tooltip.model';

@Directive({
  selector: '[mlTooltip]',
  hostDirectives: [
    {
      directive: NgpTooltipTrigger,
      inputs: [
        'ngpTooltipTriggerPlacement: mlTooltipPlacement',
        'ngpTooltipTriggerDisabled: mlTooltipDisabled',
      ],
    },
  ],
})
export class TooltipDirective {
  readonly content = input.required<string>({ alias: 'mlTooltip' });
  readonly variant = input<TooltipCva>('dark', { alias: 'mlTooltipVariant' });
  readonly placement = input<TooltipPlacement>('top', { alias: 'mlTooltipPlacement' });
  readonly disabled = input<boolean>(false, { alias: 'mlTooltipDisabled' });

  private readonly triggerState = injectTooltipTriggerState();

  constructor() {
    const state = this.triggerState();

    state.tooltip.set(TooltipComponent);

    effect(() => {
      const ctx: TooltipContext = {
        content: this.content(),
        variant: this.variant(),
      };
      state.context.set(ctx);
    });
  }
}
